var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGalderma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.782,
    height: 29.344,
    viewBox: "0 0 161.782 29.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(-549.921 -496.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M562.142,506.445v4.637a12.106,12.106,0,0,1-2.81.343c-3.975,0-7.127-2.17-7.127-6.761,0-4.157,2.558-6.693,6.442-6.693a6.916,6.916,0,0,1,5.733,2.855l-.708-3.609a18.461,18.461,0,0,0-4.682-.64c-6.167,0-9.068,4.18-9.068,8.474,0,4.751,3.358,7.789,8.36,7.789a9.789,9.789,0,0,0,4.317-.914l1.667.937v-6.419l.868-1.667h-4.02Z",
    transform: "translate(0 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M646.208,497.834H643.65l.891,1.622L638.67,512l-1.439,1.6H641.3l-1.051-1.439,2.124-4.957h5.642l2.124,4.934L649.2,513.6h4.614L652.4,511.95Zm-3.312,8.132,2.284-5.322,2.307,5.322Z",
    transform: "translate(-66.684 -0.96)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M736.322,509.918V499.5l1.028-1.668h-4.2l1.028,1.668v12.38l-1.028,1.713h10.3l.891-2.444a56.06,56.06,0,0,1-7.926,1.142C736.345,511.608,736.322,510.831,736.322,509.918Z",
    transform: "translate(-139.94 -0.96)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1181.121,513.6l-1.416-1.645-6.19-14.116h-2.558l.891,1.622-5.87,12.54-1.439,1.6h4.066l-1.051-1.439,2.124-4.957h5.642l2.124,4.934-.937,1.462Zm-10.919-7.629,2.284-5.322,2.307,5.322Z",
    transform: "translate(-469.418 -0.96)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M986.18,502.334c0-2.9-2.353-4.5-7.2-4.5h-4.957l1.028,1.668v12.38l-1.028,1.713h4.18l-1.028-1.713v-5.3l8.132,7.013h3.426l-8.749-6.784C984.078,506.583,986.18,504.87,986.18,502.334Zm-9,3.472v-4.294c0-.777.023-1.645.091-2.444h1.759c3.381,0,4.888,1.005,4.888,3.358,0,3.4-3.518,3.381-5.87,3.381Z",
    transform: "translate(-323.915 -0.96)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1075.667,499.5l.937-1.668h-3.221l.091,1.371-5.459,11.261-6.1-12.632h-2.536l1.211,2.4-1.074,11.581-1.53,1.782h4.226l-1.12-1.622.548-9.639,5.893,11.718h.3l5.8-12.266.662,10.142-1.142,1.668h4.614l-1.188-1.668Z",
    transform: "translate(-388.039 -0.96)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M819.585,505.532c0-4.751-3.289-7.7-9.32-7.7H804.92l1.028,1.668v12.38L804.92,513.6h5.345C816.478,513.6,819.585,510.169,819.585,505.532Zm-9.548,6.693-1.85.023c-.068-.685-.091-1.439-.091-2.33v-8.406c0-.731.023-1.553.068-2.307h1.873c4.911,0,7.264,2.353,7.264,6.487C817.3,509.643,815.062,512.179,810.037,512.224Z",
    transform: "translate(-194.757 -0.96)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M898.885,509.918v-4.112c2.284.046,5.254.183,7.31.411l-.343-1.622-6.967.114v-3.2c0-.777.023-1.622.068-2.421a44.147,44.147,0,0,1,7.789,1.1l-.891-2.353H895.71l1.028,1.668v12.38L895.71,513.6h10.37l.891-2.467a46.443,46.443,0,0,1-7.995,1.165C898.908,511.608,898.885,510.831,898.885,509.918Z",
    transform: "translate(-264.099 -0.96)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M829.671,604.452h2.3v-.5h-2.3v-1.4h2.424v-.5h-2.969v4.339h3.031v-.5h-2.485Z",
    transform: "translate(-213.245 -80.558)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M932.114,603.886a1.041,1.041,0,0,0,.7-1c0-.682-.539-1.2-1.469-1.2s-1.469.514-1.469,1.2a1.041,1.041,0,0,0,.7,1,1.091,1.091,0,0,0-.824,1.066c0,.694.564,1.246,1.593,1.246s1.593-.552,1.593-1.246A1.091,1.091,0,0,0,932.114,603.886Zm-1.7-.973c0-.447.31-.744.93-.744s.93.3.93.744-.31.744-.93.744S930.415,603.359,930.415,602.913Zm.93,2.8c-.694,0-1.041-.335-1.041-.787s.347-.787,1.041-.787,1.042.335,1.042.787S932.039,605.709,931.345,605.709Z",
    transform: "translate(-290.099 -80.278)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M897.015,602.691v.527l1.153-.589v3.762h.533v-4.339h-.44Z",
    transform: "translate(-265.096 -80.558)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M912.589,601.685a1.5,1.5,0,0,0-1.612,1.512,1.448,1.448,0,0,0,1.475,1.494,1.354,1.354,0,0,0,.837-.273l-1.339,1.692h.651l.93-1.227a2.752,2.752,0,0,0,.645-1.661A1.48,1.48,0,0,0,912.589,601.685Zm-.013,2.535a1.026,1.026,0,1,1,1.054-1.023A.96.96,0,0,1,912.576,604.22Z",
    transform: "translate(-275.759 -80.277)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M849.752,603.749l-.7-.167c-.576-.136-.781-.347-.781-.682,0-.452.372-.719.992-.719a1.27,1.27,0,0,1,1.159.558l.428-.26a1.651,1.651,0,0,0-1.574-.793c-.967,0-1.562.508-1.562,1.221,0,.589.409.967,1.209,1.159l.7.167c.539.13.768.353.768.706,0,.459-.39.763-1.047.763a1.362,1.362,0,0,1-1.32-.768l-.44.254a1.737,1.737,0,0,0,1.754,1.01c1.029,0,1.618-.521,1.618-1.277C850.955,604.332,850.6,603.954,849.752,603.749Z",
    transform: "translate(-227.342 -80.277)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M948.394,602.691v.527l1.153-.589v3.762h.533v-4.339h-.44Z",
    transform: "translate(-304.337 -80.558)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M882.6,617.481a.372.372,0,1,0,.372.366A.35.35,0,0,0,882.6,617.481Z",
    transform: "translate(-253.8 -92.341)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M866.089,602.561h1.451v3.831h.545v-3.831h1.45v-.508h-3.446Z",
    transform: "translate(-241.476 -80.558)",
    fill: "#161615"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalderma);
export default __webpack_public_path__ + "static/media/galderma.b75e4f028b23774eaf0b398f07d7d6dd.svg";
export { ForwardRef as ReactComponent };